import React, { useState, useEffect } from "react";
import { Button, Empty, Form, Input, Select, Card, Divider, Radio } from "antd";
import EvaluationSettingTable from "../EvaluationSettingTable";
import useJDStore from "../../store/jd.store";
import "./settings.scss";
import useQCEStore from "../../store/qce.store";
import useGlobalQCEStore from "../../store/globalqce.store";

const currentTeamTitles = [
  "Select",
  "S. No.",
  "Skill",
  "Assessment Type",
  "Level",
  "No of Question",
  "Weightage",
  "Passing Marks",
];

function EvaluationSetup({
  setView,
  exist = false,
  qhjid = null,
  ev_id = null,
  evalDesc = null,
  globalEvaluationPage = false,
}) {
  console.log(evalDesc, "evalDesc");
  const [form] = Form.useForm();
  const { selectedJD } = useJDStore();
  const { CreateNewEval } = useQCEStore();
  const { CreateNewGlobalEval, updateGlobalEval } = useGlobalQCEStore();

  const [encodedSkillSet, setEncodedSkillSet] = useState([{}]);
  const [totalQ, setTotalQ] = useState(0);
  const [marksTotal, setMarksTotal] = useState(0);
  const [marksWTotal, setMarksWTotal] = useState(0);
  var skillListNew = globalEvaluationPage
    ? []
    : selectedJD?.JDRequired?.kwarray.map((item, idx) => ({
        select: "",
        id: idx,
        skill: item,
        assessmenttype: "Domain",
        difficultylevel: "Expert",
        noofquestions: 5,
        weightage: 1,
        passingmarks: 4,
      })) || [];
  const [skillList, setSkillList] = useState(skillListNew);

  const joinWithUnderscore = (arr) => {
    return arr
      ?.map((item) => item.skill) // 1. Extract the skill names
      .filter((skill) => skill && skill !== "Please Add") // 2. Filter out empty values or the placeholder
      .slice(0, 2) // 3. Take only the first 2 valid skills
      .join("_"); // 4. Join them together with an underscore
  };
  console.log(evalDesc, "evalDesc");
  const evalDescFormatted = {
    name: evalDesc?.generalsetting.name
      ? evalDesc?.generalsetting.name
      : joinWithUnderscore(skillList),
    duration: evalDesc?.generalsetting.duration,
    mode: evalDesc?.generalsetting.mode,
    proctoringrequired: evalDesc?.proctoringrequired ? 1 : 2,
  };

  console.log(evalDesc, "evalDesc");
  useEffect(() => {
    //if eval already exits, set the values coming from backend
    console.log("evalDesc", evalDesc, exist);
    if (exist && evalDesc?.skillarray) {
      skillListNew = evalDesc?.skillarray.map((item, idx) => ({
        select: "",
        id: idx,
        skill: item.skill,
        assessmenttype: item.assessmenttype,
        difficultylevel: item.level,
        noofquestions: item.numq,
        weightage: item.weightage,
        passingmarks: item.passingmarks,
      }));
      setSkillList(() => [...skillListNew]);
    }
    var initJson = initSkillJson();
    setEncodedSkillSet(() => [...initJson]);
  }, []);

  function getTimeNow() {
    const today = new Date();
    const month = today.getMonth() + 1;
    const year = today.getFullYear();
    const date = today.getDate();
    const currentDate = date + "-" + month + "-" + year;
    return currentDate;
  }
  function resetcounters(skillA) {
    //reset the ids
    for (let idx = 0; idx < skillA.length; idx++) {
      skillA[idx].skillid = idx;
    }
  }

  function encodeForSkillList(newSkillArray) {
    console.log(newSkillArray, "newSkillArray");
    return newSkillArray.map((item) => ({
      select: "",
      id: item.skillid,
      skill: item.skill,
      assessmenttype: item.assessmenttype,
      difficultylevel: item.level,
      noofquestions: item.numq,
      weightage: item.weightage,
      passingmarks: item.passingmarks,
    }));
  }

  const reInitencodedJson = (json, action) => {
    var idexToModify = 0;
    var currentSkillSet = encodedSkillSet;
    console.log("ENCODED sKILLSET", encodedSkillSet);
    console.log("JOSBN ", json);
    var newSkills = [{}];
    var skillsAfterRemoved = encodedSkillSet;
    for (let idx = 0; idx < json.skillarray.length; idx++) {
      if (action == "ADD") {
        action = "ADD";
        newSkills[idx] = {};
        console.log(json.skillarray[idx], "json.skillarray[idx]");
        newSkills[idx].skillid = json.skillarray[idx].skillid;
        console.log("after assigning skillid", newSkills[idx].skillid);
        newSkills[idx].skill = json.skillarray[idx].skill;
        newSkills[idx].assessmenttype = json.skillarray[idx].assessmenttype;
        newSkills[idx].level = json.skillarray[idx].difficultylevel;
        newSkills[idx].numq = json.skillarray[idx].noofquestions;
        newSkills[idx].weightage = json.skillarray[idx].weightage;
        newSkills[idx].passingmarks = json.skillarray[idx].passingmarks;
        newSkills[idx].passingpercentage = json.skillarray[idx].passingmarks;
      } else if (action == "UPDATE") {
        idexToModify = json.skillarray[idx].skillid;
        currentSkillSet[idexToModify] = {};
        currentSkillSet[idexToModify].skillid = json.skillarray[idx].skillid;
        currentSkillSet[idexToModify].skill = json.skillarray[idx].skill;
        currentSkillSet[idexToModify].assessmenttype =
          json.skillarray[idx].assessmenttype;
        currentSkillSet[idexToModify].level =
          json.skillarray[idx].difficultylevel;
        currentSkillSet[idexToModify].numq = json.skillarray[idx].noofquestions;
        currentSkillSet[idexToModify].weightage =
          json.skillarray[idx].weightage;
        currentSkillSet[idexToModify].passingmarks =
          json.skillarray[idx].passingmarks;
        currentSkillSet[idexToModify].passingpercentage =
          json.skillarray[idx].passingmarks;
      } else if (action == "DELETE") {
        idexToModify = json.skillarray[idx].skillid;
        skillsAfterRemoved = skillsAfterRemoved.filter(
          (item) => item.skillid != idexToModify,
        );
      }
    }

    console.log(currentSkillSet, "currentSkillSet");
    console.log(newSkills, "newSkills");

    if (action == "UPDATE") {
      resetcounters(currentSkillSet);
      // setSkillList((prev) => [...currentSkillSet, ...prev]);
      setEncodedSkillSet(() => [...currentSkillSet]);
      recalculateCounters(encodedSkillSet);
      console.log(currentSkillSet, "currentSkillSet");
      const formattedSkillSetList = [...encodeForSkillList(currentSkillSet)];
      setSkillList(formattedSkillSetList);
      console.log(
        formattedSkillSetList,
        "formattedSkillSetList after updating skills",
      );
      const newName =
        joinWithUnderscore(formattedSkillSetList) ||
        evalDesc?.generalsetting.name;

      form.setFieldsValue({ name: newName });
    }
    if (action == "ADD") {
      console.log("newSkills in evaluation setup", newSkills);
      var newSkillsSet = [...encodedSkillSet, ...newSkills];
      // resetcounters(newSkills);
      const tempNewSkillSet = newSkillsSet.map((item) => ({}));
      const formattedSkillSetList = [
        ...skillList,
        ...encodeForSkillList(newSkills),
      ];
      setSkillList(formattedSkillSetList);
      console.log(
        formattedSkillSetList,
        "formattedSkillSetList after adding new skills",
      );
      const newName =
        joinWithUnderscore(formattedSkillSetList) ||
        evalDesc?.generalsetting.name;

      form.setFieldsValue({ name: newName });

      setEncodedSkillSet(() => [...newSkillsSet]);
    }

    if (action == "DELETE") {
      resetcounters(skillsAfterRemoved);
      setEncodedSkillSet(() => [...skillsAfterRemoved]);
      recalculateCounters(skillsAfterRemoved);
    }
  };

  function recalculateCounters(skillSet) {
    var tQ = 0,
      marks = 0,
      marksW = 0,
      weightage = 0;

    console.log(skillSet, "recalculatecounters");
    for (let idx = 0; idx < skillSet.length; idx++) {
      //console.log("Index", idx, skillSet[idx])
      tQ = tQ + (1 * skillSet[idx].numq || skillSet[idx].noofquestions);
      console.log(tQ, "Total questions");
      marks = marks + 1 * skillSet[idx].passingmarks;
      weightage = skillSet[idx].weightage;
      weightage =
        typeof weightage === "string"
          ? weightage == "Mandatory"
            ? 1
            : 0
          : weightage;
      marksW = marksW + skillSet[idx].passingmarks * weightage;
    }
    console.log(tQ, "Total final questions");

    setTotalQ(tQ);
    setMarksTotal(marks);
    setMarksWTotal(marksW);
  }

  const initSkillJson = () => {
    var skillarray = [{}];
    var tQ = 0,
      marks = 0,
      marksW = 0,
      weightage = 0;

    if (!skillListNew || skillListNew.length === 0) return [];
    for (let idx = 0; idx < skillListNew.length; idx++) {
      skillarray[idx] = {};
      skillarray[idx].skillid = idx;
      skillarray[idx].skill = skillListNew[idx].skill;
      skillarray[idx].assessmenttype = skillListNew[idx].assessmenttype;
      skillarray[idx].level = skillListNew[idx].difficultylevel;
      skillarray[idx].numq = skillListNew[idx].noofquestions;
      skillarray[idx].weightage = skillListNew[idx].weightage;
      skillarray[idx].passingmarks = skillListNew[idx].passingmarks;
      skillarray[idx].passingpercentage = skillListNew[idx].passingmarks;

      //
      tQ = tQ + 1 * skillarray[idx].numq;
      marks = marks + 1 * skillarray[idx].passingmarks;
      weightage = skillarray[idx].weightage;
      marksW = marksW + skillarray[idx].passingmarks * weightage;
    }

    setTotalQ(tQ);
    setMarksTotal(marks);
    setMarksWTotal(marksW);

    return skillarray;
  };

  const encodeJson = (value) => {
    const userData = JSON.parse(localStorage.getItem("userDetails"));
    let encodedJsonValues = {};

    //console.log("values",value)

    if (exist == false) {
      encodedJsonValues.action = "New";
      encodedJsonValues.state = "Offline";
    } else {
      encodedJsonValues.action = "Update";
      encodedJsonValues.qhevid = ev_id;
    }
    encodedJsonValues.name =
      value?.name == null
        ? skillListNew?.[0]?.skill.toUpperCase() + " Assesment"
        : value.name;
    encodedJsonValues.duration = value.duration == null ? "60" : value.duration;
    encodedJsonValues.duration = parseInt(encodedJsonValues.duration);
    encodedJsonValues.totalq = totalQ;
    encodedJsonValues.passingmarks = marksTotal;
    encodedJsonValues.wpassingmarks = marksWTotal;
    encodedJsonValues.passingpercentage = marksTotal; //unsupported
    encodedJsonValues.mode =
      value.mode == null ? "Autogenerate Using AI" : value.mode;
    encodedJsonValues.proctoringrequired =
      value.proctoringrequired == 1 ? true : false;
    //get the current date
    let newDate = getTimeNow();
    encodedJsonValues.updatedby = {};
    encodedJsonValues.updatedby.qhuid = userData.qhuid;
    encodedJsonValues.updatedby.updatedbyname = userData.username;
    encodedJsonValues.updatedby.updatedon = newDate;

    encodedJsonValues.skillreq = {};
    encodedJsonValues.skillreq.skillarray = encodedSkillSet;
    encodedJsonValues.skillreq.updatedby = encodedJsonValues.updatedby;
    if (exist == false) {
      encodedJsonValues.skillreq.action = "ADD";
    } else {
      encodedJsonValues.action = "Update";
    }

    return encodedJsonValues;
  };

  const handleFormSubmit = (value) => {
    var jasonValues = encodeJson(value);
    console.log("Encoded data", jasonValues);
    if (globalEvaluationPage) {
      CreateNewGlobalEval({
        jasonValues,
      });
    } else {
      CreateNewEval({
        jasonValues,
        qhjid,
      });
    }
    setView("all");
  };

  return (
    <div className="evaluation-setup-container">
      <div className="e-members-wrapper">
        <div className="e-members-list-heading">Skills Settings</div>

        <EvaluationSettingTable
          titleList={currentTeamTitles}
          data={skillList}
          config={`50px 0.5fr 2fr 2fr 2fr 2fr 2fr 2fr 2fr 2fr`}
          handleSkillUpdate={reInitencodedJson}
          recalculateCounters={recalculateCounters}
        />

        <div className="e-members-list-heading">Questions Set Settings</div>
        <div className="e-member-list-count">
          <div className="e-member-list-count-item">
            <Card title="Total Q" bordered={false}>
              {totalQ}
            </Card>
          </div>
          <div className="e-member-list-count-item">
            <Card title="Passing Marks " bordered={false}>
              {marksTotal}
            </Card>
          </div>
          <div className="e-member-list-count-item">
            <Card title="Passing Marks (Mandatory Skills)" bordered={false}>
              {marksWTotal}
            </Card>
          </div>
        </div>
        <div className="e-members-list-heading">General Settings</div>
        <div className="e-members-list-item">
          <Form
            name="evaluation-form"
            justify="start"
            layout="vertical"
            autoComplete="off"
            form={form}
            initialValues={evalDescFormatted}
            onFinish={handleFormSubmit}
          >
            <Form.Item required={true} name="name" label="Assesment Name">
              <Input required={true} className="e-members-input" />
            </Form.Item>
            <Form.Item
              required={true}
              name="duration"
              label="Assesment Duration (Mins)"
            >
              <Input required={true} className="e-members-input" />
            </Form.Item>

            <Form.Item name="mode" required={true} label="Generation Mode">
              <Select
                required={true}
                name="mode"
                className="e-members-input"
                options={[
                  {
                    value: "Autogenerate Using AI",
                    label: "Autogenerate using AI",
                  },
                  { value: "Custom Questions", label: "Custom Questions" },
                ]}
              />
            </Form.Item>

            <Form.Item
              name="proctoringrequired"
              required={true}
              label="Proctoring Enabled"
            >
              <Radio.Group
                horizontal
                options={[
                  { value: 1, label: "Yes" },
                  { value: 2, label: "No" },
                ]}
              />
            </Form.Item>

            <Button type="primary" htmlType="submit">
              {exist ? "Update" : "Create Now"}
            </Button>
          </Form>
        </div>
        <div>
          <Divider />
        </div>
      </div>
    </div>
  );
}

export default EvaluationSetup;
